export default __webpack_public_path__ + "static/media/img2.c25231a7.webp";